module.exports = __webpack_public_path__ + "img/i_c_new_07.28e6751b.svg";